// import React, { useState, useEffect } from 'react';
// import InstituteDashboard from './InstituteDashboard';
//
// const ManageLangQual = () => {
//     const [langQualifications, setLangQualifications] = useState([]);
//
//     useEffect(() => {
//         fetchLangQualifications();
//     }, []);
//
//
//     const fetchLangQualifications = async () => {
//         try {
//             const response = await fetch('https://api.myskills.lk/langQualifications/all');
//             const data = await response.json();
//             setLangQualifications(data);
//         } catch (error) {
//             console.error('Error fetching Language Qualifications:', error);
//         }
//     };
//
//     const handleDelete = async (langQualificationsId) => {
//         try {
//             const response = await fetch(`https://api.myskills.lk/langQualifications/delete/${langQualificationsId}`, {
//                 method: 'POST'
//             });
//             if (response.ok) {
//                 setLangQualifications(langQualifications.filter(langQualifications => langQualifications.id !== langQualificationsId));
//             } else {
//                 console.error('Failed to delete Language Qualification');
//             }
//         } catch (error) {
//             console.error('Error deleting Language Qualification:', error);
//         }
//     };
//
//     return (
//         <div>
//             <InstituteDashboard />
//             <div className='AllViews-admin-course'>
//                 <div className="search-icon-admin admin-course-search">
//                     <h1>MANAGE LANGUAGE QUALIFICATIONS</h1>
//                     <form>
//                         <input type="text" placeholder='Search Item' />
//                         <input type="submit" value="SEARCH" />
//                     </form>
//                 </div>
//
//                 <div className="scroller-box">
//                     <div className="table-course">
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Language Exam Name</th>
//                                     <th>Institute Name</th>
//                                     <th>Teaching Method</th>
//                                     <th>Duration</th>
//                                     <th>Course Fee</th>
//                                     <th>Paying Method</th>
//                                     <th>Contact No.</th>
//                                     <th>Email</th>
//                                     <th>View</th>
//                                     <th>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                             {langQualifications.map((langQualifications) => (
//                                     <tr key={langQualifications.id}>
//                                         <td>{langQualifications.langQualName}</td>
//                                         <td>{langQualifications.university}</td>
//                                         <td>{langQualifications.teachingMethod}</td>
//                                         <td>{langQualifications.duration}</td>
//                                         <td>{langQualifications.courseFee}</td>
//                                         <td>{langQualifications.payMethod}</td>
//                                         <td>{langQualifications.institutePhone}</td>
//                                         <td>{langQualifications.instituteEmail}</td>
//                                         <td>
//                                             <a href={langQualifications.instituteWebsite} target="_blank" rel="noopener noreferrer">
//                                                 View Website
//                                             </a>
//                                         </td>
//                                         <td id='action-buttons'>
//                                             {/* <a href="#!" id='man-details' onClick={() => handleEdit(Scholarships.id)}>EDIT</a> */}
//                                             <a href="#!" id='del-details' onClick={() => handleDelete(langQualifications.id)}>DELETE</a>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default ManageLangQual;
//



import React, { useState, useEffect } from 'react';
import InstituteDashboard from './InstituteDashboard';
import '../../assets/css/Institute/CreateCourse.css';

const ManageLangQual = () => {
    const [langQualifications, setLangQualifications] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editedLangQual, setEditedLangQual] = useState({});
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchLangQualifications();
    }, []);

    const fetchLangQualifications = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/langQualifications/all');
            const data = await response.json();
            setLangQualifications(data);
        } catch (error) {
            console.error('Error fetching Language Qualifications:', error);
        }
    };

    const handleEdit = (item) => {
        setEditingId(item.id);
        setEditedLangQual({ ...item });
    };

    const handleCancel = () => {
        setEditingId(null);
        setEditedLangQual({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedLangQual((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSave = async (id) => {
        try {
            const response = await fetch(`https://api.myskills.lk/langQualifications/update/${id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(editedLangQual),
            });

            if (response.ok) {
                setLangQualifications((prev) =>
                    prev.map((item) => (item.id === id ? editedLangQual : item))
                );
                setEditingId(null);
                setEditedLangQual({});
            } else {
                console.error('Failed to update language qualification');
            }
        } catch (error) {
            console.error('Error updating language qualification:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(`https://api.myskills.lk/langQualifications/delete/${id}`, {
                method: 'POST'
            });
            if (response.ok) {
                setLangQualifications((prev) => prev.filter((item) => item.id !== id));
            } else {
                console.error('Failed to delete language qualification');
            }
        } catch (error) {
            console.error('Error deleting language qualification:', error);
        }
    };

    return (
        <div>
            <InstituteDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>MANAGE LANGUAGE QUALIFICATIONS</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="text"
                            placeholder="Search by Programme, Country, or University"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH"/>
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                            <tr>
                                <th>Language Exam Name</th>
                                <th>Institute Name</th>
                                <th>Teaching Method</th>
                                <th>Duration</th>
                                <th>Course Fee</th>
                                <th>Paying Method</th>
                                <th>Contact No.</th>
                                <th>Email</th>
                                <th>View</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {langQualifications
                                .filter((search) =>
                                    search.langQualName.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                .map((item) => (
                                <tr key={item.id}>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="langQualName"
                                                value={editedLangQual.langQualName || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.langQualName
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="university"
                                                value={editedLangQual.university || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.university
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="teachingMethod"
                                                value={editedLangQual.teachingMethod || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.teachingMethod
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="duration"
                                                value={editedLangQual.duration || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.duration
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="courseFee"
                                                value={editedLangQual.courseFee || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.courseFee
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="payMethod"
                                                value={editedLangQual.payMethod || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.payMethod
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="institutePhone"
                                                value={editedLangQual.institutePhone || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.institutePhone
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="email"
                                                name="instituteEmail"
                                                value={editedLangQual.instituteEmail || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            item.instituteEmail
                                        )}
                                    </td>
                                    <td>
                                        {editingId === item.id ? (
                                            <input
                                                type="text"
                                                name="instituteWebsite"
                                                value={editedLangQual.instituteWebsite || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            <a
                                                href={item.instituteWebsite}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View Website
                                            </a>
                                        )}
                                    </td>
                                    <td id="action-buttons">
                                        {editingId === item.id ? (
                                            <>
                                                <a href="#!" id="man-details" onClick={() => handleSave(item.id)}>SAVE</a>{' '}
                                                <a href="#!" id="del-details" onClick={handleCancel}>CANCEL</a>
                                            </>
                                        ) : (
                                            <>
                                                <a href="#!" id="man-details" onClick={() => handleEdit(item)}>EDIT</a>{' '}
                                                <a href="#!" id="del-details" onClick={() => handleDelete(item.id)}>DELETE</a>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageLangQual;

